// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1792672274144
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/ParadigmaModal/ParadigmaModal.scss
// module id = ./src/components/ParadigmaModal/ParadigmaModal.scss
// module chunks = 0